import { createApiV2 } from "./common";

export const getCountries = () => createApiV2("GET", "countries/")();
